var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step",class:_vm.className},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.step === this.currentStep),expression:"this.step === this.currentStep"}],staticClass:"desc"},[_vm._t("desc")],2),_vm._v(" "),_vm._t("add-info")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }